let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aHtXH")).then(() => parcelRequire('cB0p5'));